import { combineReducers } from "redux";

import careerbanner from "../features/components/careercounselling/careerbanner/Slice";

import whatcareer from "../features/components/careercounselling/whatcareer/Slice";

import careerprocess from "../features/components/careercounselling/careerprocess/Slice";

import whoshouldopt from "../features/components/careercounselling/whoshouldopt/Slice";

import common from "../features/components/common/Slice";

const careercounselling = combineReducers({
    careerbanner,
    whatcareer,
    careerprocess,
    whoshouldopt,
    common
});

export default careercounselling;